// Add dashboard to track:
// Avg $ to bring workers from 'New' to 'Experienced' to other tiers (come up with tiers)
// Avg num jobs per worker


import * as React from 'react'
import { useSelector } from 'react-redux'
import * as _ from 'lodash'

import Communications from './Communications'
import Dashboard from './Dashboard'
import Manual from './Manual'
import Testing from './Testing'
import { IAppState } from '../../redux/reducers'


interface WorkerDevProps {
    
}

const WorkerDev : React.FunctionComponent<WorkerDevProps> = ({ }) : JSX.Element => {
    const [activeWD, setActiveWD] = React.useState('dashboard')
    let auth = useSelector((state:IAppState) => state.auth)
    const userRole = auth && auth.userData &&  _.isArray(auth.userData.roles) && auth.userData.roles[0]
    //alert(userRole)
    let fk_companies = auth.userData && auth.userData.fk_companies ? auth.userData.fk_companies : []

    /*switch(userRole) {
        case 'worker':
            return <p>Worker</p>
        default:
            return <p>Hi</p>
    }*/

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '200px 3fr', height: '100vh' }}>
            <div className='light-orangex' style={{ backgroundColor: '#B2ACA7', color: 'white', fontWeight: 'bold' }}>
                <h2>Worker Dev</h2>
                <div>
                    <a href='#' className='white-link' onClick={() => { setActiveWD('dashboard') }}>
                        <p>Dashboard</p>
                    </a>
                </div>
                <div>
                    <a href='#' className='white-link' onClick={() => { setActiveWD('communications') }}>
                        <p>Communications</p>
                    </a>
                </div>
                <div>
                    <a href='#' className='white-link' onClick={() => { setActiveWD('manual') }}>
                        <p>Manual</p>
                    </a>
                </div>
                <div>
                    <a href='#' className='white-link' onClick={() => { setActiveWD('testing') }}>
                        <p>Testing</p>
                    </a>
                </div>
            </div>
            <div>
                {activeWD == 'dashboard' && <Dashboard />}
                {activeWD == 'communications' && <Communications />}
                {activeWD == 'manual' && <Manual />}
                {activeWD == 'testing' && <Testing /> }
                <br /><br /><br />
            </div>
        </div>
    )
}

export default WorkerDev